/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
const COMPONENT_NAME = "Admin handling/services/ContactService";

/**
 * Updates the new contact attributes for a Contact ID to AMAZON Connect
 */
export const updateContactAttributes = async (contactId, contactAttributes) => {
	try {
		let response = await axios.post(`${APIGateways.contactAttributesEndpoint}/${contactId}`, contactAttributes, {
			headers: await getAuthHeader(),
		});
		return response.data.result;
	} catch (error) {
		v2.error(`Error updating contact attributes`, {
			additionalData: {
				error: errorToObject(error),
				contactId,
			},
			logCode: errorCodes.UPDATE_CONTACT_ATTRIBUTES_ERROR,
			componentName: COMPONENT_NAME,
		});
		if (error.message === "Network Error") {
			throw error;
		} else {
			throw new Error("Error while updating the contact.");
		}
	}
};

/**
 * Fetches the existing contact attributes for a Contact ID  stored in AMAZON Connect.
 */
export const getContactAttributes = async (contactId) => {
	try {
		let response = await axios.get(`${APIGateways.contactAttributesEndpoint}/${contactId}`, {
			headers: await getAuthHeader(),
		});
		return response.data.attributes;
	} catch (error) {
		let err;
		if (error.response.status === 500 && error.response.data.error === "Resource not found") {
			err = new Error("No Contact found.");
			err.code = 404;
		} else {
			v2.error(`Error getting contact attributes`, {
				additionalData: {
					error: errorToObject(error),
				},
				logCode: errorCodes.GET_CONTACT_ATTRIBUTES_ERROR,
				componentName: COMPONENT_NAME,
			});
			err = new Error("Network Error.");
			err.code = 500;
		}
		throw err;
	}
};
